// extracted by mini-css-extract-plugin
export default {"root":"UgCi9","muroIcon":"_1rUC1","newIcon":"_1Ag43"};